import React, { useMemo, useState } from "react";
import { Box, Container } from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import CoursesFormCst from "../CoursesFormCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useEditCourses } from "@hooks/hookscatalog/Courses/useEditCourses";
import { PagesID } from "@utils/utilsConfigurations";
import { useAuth } from "@context/auth";

const EditCourses: React.FC<{
  duplication?: boolean;
}> = ({ duplication = false }) => {
  const { user } = useAuth();
  const { t } = useTranslation(["courses-page"]);
  const { idLO, id } = useParams();
  const navigate = useNavigate();
  const [confirmCompletedLOModal, setConfirmCompletedLOModal] =
    useState<any>(undefined);

  const readOnly =
    (user?.permissions.includes("learning_catalogue.learning_object.read") &&
      !user?.permissions.includes(
        "learning_catalogue.learning_object.write",
      )) ??
    false;

  const {
    onSubmit,
    openToast,
    setOpenToast,
    columns,
    dataDetail,
    actionsForForms,
  } = useEditCourses(
    PagesID["corporate.catalog.courses"],
    id,
    idLO,
    duplication,
  );

  const formatData = useMemo(() => {
    const formatArr = { ...dataDetail };
    if (formatArr && Object.keys(formatArr).length > 0) {
      if (!!duplication) {
        return {
          ...dataDetail,
          publish_date: null,
          title: `${dataDetail.title} - Copied`,
          completable: false,
        };
      } else {
        return { ...dataDetail };
      }
    } else {
      return {};
    }
  }, [dataDetail]);

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-courses.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t(`edit.hero-title${duplication ? "-duplicate" : ""}`)}
          description={t("edit.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <CoursesFormCst
              row={formatData}
              columns={columns}
              onSubmit={onSubmit}
              setConfirmCompletedLOModal={setConfirmCompletedLOModal}
              backButton={() => {
                navigate(`/corporate/${id}/detail/catalog/courses`);
              }}
              idEntity={idLO}
              actionsForForms={actionsForForms}
              duplication={duplication}
              idCorporate={id}
              readOnly={readOnly}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
      <ModalConfirmsCst
        open={!!confirmCompletedLOModal}
        title={t("modal-confirm-completed.hero-title")}
        description={t("modal-confirm-completed.hero-description")}
        onCallBackClosed={() => {
          setConfirmCompletedLOModal(undefined);
        }}
        onActionConfirmed={() =>
          onSubmit(
            confirmCompletedLOModal.inputForm,
            confirmCompletedLOModal.fileUploaded,
          )
        }
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default EditCourses;
